import cx from 'classnames';
import { type FC, useContext } from 'react';
import { history } from 'umi';
import { LayoutContext } from '@/layouts/MCLayout';

type LabelType = {
  label: string;
  key: string;
  children?: LabelType[];
};

type MenuProps = {
  items: LabelType[];
  selectedKeys: string[];
};

const Menu: FC<MenuProps> = (p) => {
  const { items, selectedKeys } = p;

  const handleGo = (path: string) => {
    const { pathname } = window.location;
    if (path !== pathname) {
      history.push(path);
    }
  };

  return (
    <ul className="w-[180px] h-[667px] pl-[40px] py-[32px] space-y-[50px] bg-white">
      {items?.map((item) => (
        <li key={item.key}>
          <div className="text-[16px] font-medium text-secondary mb-[32px]">
            {item.label}
          </div>
          <ul className="space-y-[32px]">
            {item?.children?.map((child) => (
              <li
                key={child.key}
                className={cx(
                  'text-[#595959] cursor-pointer underline-offset-[8px] hover:font-medium hover:text-secondary hover:underline',
                  {
                    ['text-secondary font-medium underline']:
                      selectedKeys?.includes(child.key),
                  },
                )}
                onClick={() => handleGo(child.key)}
              >
                {child.label}
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
};

const SiderMenu: FC = () => {
  const { menus, selectedKeys = [] } = useContext(LayoutContext);

  return <Menu items={menus as LabelType[]} selectedKeys={selectedKeys} />;
};

export default SiderMenu;
